
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 64 44","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('g',{attrs:{"transform":"matrix(-1 0 0 1 61 2)","stroke":"currentColor"}},[_c('ellipse',{attrs:{"stroke-width":"2","cx":"10.694","cy":"12.304","rx":"6.344","ry":"6.379"}}),_c('path',{attrs:{"d":"M1.055 38.636C.352 35.824 0 33.363 0 31.255c0-3.164.066-6.509 2.175-7.563 0 0 .906-.547 2.044-.873 1.138-.325 3.164-1.054 6.328-1.054 5.274 0 7.8.637 9.493-1.054 1.054-1.055 1.501-1.808 2.11-4.218.235-.935.587-2.693 1.054-5.272-.034-1.406.67-2.109 2.11-2.109 1.054 0 1.7.747 1.873 1.094.39.78.012 6.818-1.268 10.505-1.273 3.664-3.21 5.995-3.77 6.326-1.124.664-2.11 0-3.164 4.218-1.055 4.217.226 7.38-2.11 7.38H1.056z","stroke-width":"2"}}),_c('path',{attrs:{"d":"M23.383 2.262l3.263 3.709.972-.706L25.204.926l-1.82 1.336z","fill":"currentColor"}})]),_c('g',{attrs:{"fill":"currentColor","transform":"translate(3 2)"}},[_c('ellipse',{attrs:{"cx":"10.694","cy":"13.304","rx":"6.344","ry":"6.379"}}),_c('path',{attrs:{"d":"M1.055 38.636C.352 35.824 0 33.363 0 31.255c0-3.164.066-6.509 2.175-7.563 0 0 .906-.547 2.044-.873 1.138-.325 3.164-1.054 6.328-1.054 5.274 0 7.8.637 9.493-1.054 1.054-1.055 1.501-1.808 2.11-4.218.235-.935.587-2.693 1.054-5.272-.034-1.406.67-2.109 2.11-2.109 1.054 0 1.7.747 1.873 1.094.39.78.012 6.818-1.268 10.505-1.273 3.664-3.21 5.995-3.77 6.326-1.124.664-2.11 0-3.164 4.218-1.055 4.217.226 7.38-2.11 7.38H1.056z"}}),_c('path',{attrs:{"d":"M23.383 2.262l3.263 3.709.972-.706L25.204.926l-1.82 1.336z","stroke":"currentColor"}})])])])
          )
        }
      }
    